/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

// 26.1.11 Reflect.ownKeys(target)
var $export = require('./$.export');

$export($export.S, 'Reflect', {ownKeys: require('./$.own-keys')});



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es6.reflect.own-keys.js
 ** module id = 1351
 ** module chunks = 0
 **/